import { useMemo } from "react"
import { CARE_RECORDS_LABEL, SHIFT_MANAGEMENT_LABEL, permittedCareRecordModules } from "../../constants/careRecords"
import usePermissionsController from "../../permissions"

// One navigation model shared by the sidebar, the mobile bottom nav and the top bar title.
// group: "main" | "care" | "admin" (drives the dividers in the sidebar).
export const isActive = (selected, href) =>
  href === "/" ? selected === "/" || selected === "" : selected.toLowerCase().startsWith(href.toLowerCase())

export function useNavItems({ mergeCareRecords = false } = {}) {
  const permissions = usePermissionsController()
  const {
    accessHomePage,
    accessAnalyticsPage,
    accessTeamsPage,
    accessSchedulePage,
    accessSettingsPage,
    accessTimesheetsPage,
    accessSubscriptionPage,
  } = permissions

  return useMemo(() => {
    const p = []
    if (accessHomePage) p.push({ name: "Home", icon: "Home", href: "/", group: "main" })
    if (accessTeamsPage) p.push({ name: "Team", icon: "Group", href: "/team", group: "main" })
    if (accessSchedulePage) p.push({ name: SHIFT_MANAGEMENT_LABEL, icon: "AddTask", href: "/schedule", group: "main" })
    const modules = permittedCareRecordModules(permissions)
    if (mergeCareRecords) {
      if (modules.length > 0) p.push({ name: CARE_RECORDS_LABEL, icon: "FolderShared", href: "/care-records", group: "care" })
    } else {
      modules.forEach((m) =>
        p.push({ name: m.label, icon: m.icon, href: `/care-records/${m.slug}`, section: CARE_RECORDS_LABEL, group: "care" })
      )
    }
    if (accessTimesheetsPage) p.push({ name: "Timesheets", icon: "PointOfSale", href: "/timesheets", group: "admin" })
    if (accessSubscriptionPage) p.push({ name: "Subscription", icon: "Payment", href: "/subscription", group: "admin" })
    if (accessAnalyticsPage) p.push({ name: "Analytics", icon: "Analytics", href: "/analytics", group: "admin" })
    if (accessSettingsPage) p.push({ name: "Settings", icon: "Settings", href: "/settings", group: "admin" })
    return p
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions, mergeCareRecords, accessHomePage, accessAnalyticsPage, accessTeamsPage, accessSchedulePage, accessSettingsPage, accessTimesheetsPage, accessSubscriptionPage])
}

// Page title for the top bar, taken from the existing nav labels.
export function pageTitleFor(pathname, items) {
  const path = pathname.toLowerCase()
  if (path.startsWith("/care-records/")) {
    const m = items.find((i) => i.href === path)
    if (m) return m.name
  }
  if (path.startsWith("/care-records")) return CARE_RECORDS_LABEL
  if (path.startsWith("/team")) return "Team"
  if (path === "/" || path === "") return "Home"
  if (path.startsWith("/schedule")) return SHIFT_MANAGEMENT_LABEL
  const hit = ["/timesheets", "/subscription", "/analytics", "/settings"].find((h) => path.startsWith(h))
  if (hit) return hit.slice(1).replace(/^./, (c) => c.toUpperCase())
  return ""
}
